// src/utils/tpnUtils.ts
import { TpnConfig } from '../types/tpnConfig';

export const hasTpnConfig = (tpnConfig: TpnConfig | null): boolean => {
  const isValid = !!(tpnConfig?.tpn_config && tpnConfig.tpn_config.length > 0);
  return isValid;
};

export const shouldShowCartIcon = (
  showCartIcon: boolean,
  tpnConfig: TpnConfig | null
): boolean => {
  const hasValidConfig = hasTpnConfig(tpnConfig);
  const shouldShow = !!(showCartIcon && hasValidConfig);
  
  return shouldShow;
};

export const isTpnActive = (tpnConfig: TpnConfig | null): boolean => {
  const active = hasTpnConfig(tpnConfig);
  return active;
};

export const getTpnConfigCount = (tpnConfig: TpnConfig | null): number => {
  const count = tpnConfig?.tpn_config?.length || 0;
  return count;
};